export type Locale = "lt" | "ru";

export function detectLocale(): Locale {
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/ru")) {
    return "ru";
  }
  return "lt";
}

export function localePath(path: string, locale: Locale): string {
  if (locale === "ru") {
    return `/ru${path === "/" ? "" : path}`;
  }
  return path;
}

export function stripLocalePrefix(pathname: string): string {
  if (pathname.startsWith("/ru")) {
    const stripped = pathname.slice(3);
    return stripped || "/";
  }
  return pathname;
}
